import { HttpResponse } from '@angular/common/http';

export class FileHelper {
    /**
     * Initiates a download of a given Blob object by creating a temporary
     * anchor element and programmatically clicking it. The file will be
     * saved to the user's device with the specified filename.
     *
     * @param blob The Blob object representing the file content to download.
     * @param filename The desired filename for the downloaded file.
     */
    static downloadBlobFile(blob: Blob, filename: string): void {
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');

        anchor.href = url;
        anchor.download = filename;

        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);

        window.URL.revokeObjectURL(url);
    }

    /**
     * Attempts to extract the filename from the 'Content-Disposition' header of an HTTP response.
     * If the header is not present or does not contain a filename, it returns null.
     *
     * @param response The HTTP response from which to extract the filename.
     * @returns The extracted filename or null if not found.
     */
    static getFilenameFromContentDisposition(
        response: HttpResponse<Blob>,
    ): string | null {
        const contentDisposition = response.headers.get('Content-Disposition');
        if (!contentDisposition) {
            return null;
        }

        const match = /filename\*\s*=\s*UTF-8''([^;]+)/i.exec(
            contentDisposition,
        );
        return match?.[1] ? decodeURIComponent(match[1].trim()) : null;
    }
}
